import type {MaterialNodeSettings, MaterialNodeConstructorParameters} from "#material/sockets/parameters"
import type {ColorRampSockets} from "#material/nodes/color/color-ramp/definition"
import type {ColorStop} from "#material/nodes/color/color-ramp/types"

export const stops = (settings: MaterialNodeSettings<ColorRampSockets>): ColorStop[] => {
    const stops: ColorStop[] = []
    for (let i = 0; i < numberOfStops(settings); i++) {
        const color = {
            r: settings[`colorRampElements_${i}Color_0`] ?? 0,
            g: settings[`colorRampElements_${i}Color_1`] ?? 0,
            b: settings[`colorRampElements_${i}Color_2`] ?? 0,
        }
        const alpha = settings[`colorRampElements_${i}Alpha`] ?? 1
        const position = settings[`colorRampElements_${i}Position`] ?? 0
        stops.push({color, alpha, position})
    }
    return stops
}

export const numberOfStops = (settings: MaterialNodeConstructorParameters<ColorRampSockets>["settings"] | MaterialNodeSettings<ColorRampSockets>) => {
    for (let i = 0; i < 100; i++) {
        if (settings[`colorRampElements_${i}Alpha`] === undefined) {
            return i
        }
    }
    return 100
}
